import React from 'react';
import { useSelector } from 'react-redux';
import { Link, useParams } from 'react-router-dom';

const Footer = ()=>{
    const {school} = useParams();
    const config = useSelector(state => state.config);

    return (
        <div id="footer">
            <div className="inner clear">
                <div className="left_area">
                    <div className="f_logo">
                        <img src="/repository/logo_b.png" alt="독서길라잡이 로고" />
                    </div>
                    <div className="cs_info">
                        <p className="num">고객센터 <strong>{config.csTel}</strong></p>
                        <p className="desc">운영시간 : {config.csTime}</p>
                    </div>
                </div>
                <div className="right_area">
                    <Link to={`/${school}/policy/terms`} className="btn_link">이용약관</Link><br />
                    <Link to={`/${school}/policy/privacy`} className="btn_link">개인정보처리방침</Link>
                </div>
            </div>
            <button type="button" id="moveToTop" onClick={()=>window.$("html, body").animate({scrollTop:0},300)}><span>TOP</span></button>
        </div>
    );
};
export default Footer;